/**
*
* EditDeleteControl
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import useDialog from 'containers/Dialog/useDialog.js';
import doNothing from 'utils/doNothing.js';
import ControlMenu from '../ControlMenu/index.jsx';
import messages from './messages.js';

function EditDeleteControl(props) {
  const { onEdit, onDelete, confirmDeleteText } = props;
  const { dlgConfirm } = useDialog();

  function handleDelete() {
    dlgConfirm({ title: confirmDeleteText, confirmStyle: 'danger', confirmLabel: messages.delete })
      .then(onDelete)
      .catch(doNothing);
  }

  const items = [
    { label: 'edit', handler: onEdit, disabled: !onEdit },
    { label: 'remove', handler: handleDelete, danger: true, disabled: !onDelete },
  ];
  return <ControlMenu {...props} items={items} />;
}

EditDeleteControl.propTypes = {
  confirmDeleteText: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  icon: PropTypes.string,
};

export default EditDeleteControl;
